import { Image, StyleSheet, View, Text } from '@react-pdf/renderer';
import React from 'react';
import { resolveLogoUrl } from 'PDF/TemplateEngine/utils/resolveLogoUrl';

const styles = StyleSheet.create({
  header: {
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  leftSection: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    flex: 1,
  },
  centerSection: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    flex: 2,
  },
  rightSection: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    flex: 1,
  },
  companyName: {
    fontSize: '14px',
    fontFamily: 'Helvetica-Bold',
    color: '#2c3e50',
    marginBottom: '0.1cm',
  },
  documentType: {
    fontSize: '10px',
    fontFamily: 'Helvetica',
    color: '#7f8c8d',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
  },
  title: {
    fontSize: '18px',
    fontFamily: 'Helvetica-Bold',
    color: '#548235',
    textAlign: 'center',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
  },
  subtitle: {
    fontSize: '10px',
    fontFamily: 'Helvetica',
    color: '#34495e',
    textAlign: 'center',
    marginTop: '0.1cm',
  },
  logo: {
    height: '2.5cm',
    width: '3.5cm',
    objectFit: 'contain',
    backgroundColor: '#ffffff',
    padding: '0.2cm',
    borderRadius: '0.2cm',
    border: '1px solid #e8e8e8',
    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
  },
  dateInfo: {
    fontSize: '9px',
    fontFamily: 'Helvetica',
    color: '#7f8c8d',
    textAlign: 'right',
  },
});

function Header(props) {
  const { title, config, date } = props;

  // La fecha SIEMPRE viene del documento. Antes se caia a `new Date()`
  // cuando el consumidor no la pasaba, y bajo el numero del documento se
  // imprimia la fecha de DESCARGA: el cliente veia dos fechas distintas en
  // el mismo informe. Sin fecha valida no se imprime ninguna.
  const parsed = date ? new Date(date) : null;
  const displayDate = parsed && !Number.isNaN(parsed.getTime()) ? parsed : null;

  // `portraitLogo` puede venir como URL absoluta, como path del API
  // (/api/v1/tenants/:id/logo-file) o como nombre relativo. `resolveLogoUrl`
  // cubre los tres casos; concatenar API_PATH a mano rompia los dos primeros.
  const logoSrc = resolveLogoUrl(config?.portraitLogo);

  // Determinar el tipo de documento basado en el título
  const getDocumentType = (title) => {
    if (title?.includes('ODT')) return 'Orden de Trabajo';
    if (title?.includes('Presupuesto')) return 'Presupuesto';
    if (title?.includes('Voucher')) return 'Voucher de Atención';
    return 'Documento';
  };

  return (
    <View style={styles.header}>
      {/* Sección Izquierda - Información de la Empresa */}
      <View style={styles.leftSection}>
        <Text style={styles.companyName}>{config?.company || 'Lift Logic'}</Text>
        <Text style={styles.documentType}>{getDocumentType(title)}</Text>
      </View>

      {/* Sección Central - Título del Documento */}
      <View style={styles.centerSection}>
        <Text style={styles.title}>{title}</Text>
        {displayDate ? (
          <Text style={styles.subtitle}>
            {displayDate.toLocaleDateString('es-CL', {
              year: 'numeric',
              month: 'long',
              day: 'numeric',
            })}
          </Text>
        ) : null}
      </View>

      {/* Sección Derecha - Logo */}
      <View style={styles.rightSection}>
        {logoSrc ? (
          <Image style={styles.logo} src={logoSrc} />
        ) : (
          <View
            style={[
              styles.logo,
              {
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              },
            ]}
          >
            <Text
              style={{
                fontSize: '12px',
                fontFamily: 'Helvetica-Bold',
                color: '#548235',
                textAlign: 'center',
              }}
            >
              LIFT LOGIC
            </Text>
          </View>
        )}
      </View>
    </View>
  );
}

export default Header;
